import React, {useContext, useState} from 'react';
import {PortalSelect, PortalSelectOption} from '../PortalSelect';
import {BASIC_ELEMENT_SCHEMA} from '../layout/Group';
import {ModelContext} from '../metadata/ModelSource';
import { ApplicationActionsContext } from '../data/ApplicationDataSource';
import Select, {Props} from 'react-select';
import { FormContext } from '../metadata/MDForm';
import { formatMoneyAmountNoDecimal } from '../../utils/formatUtils';
import {Attribute, AttributeCondition} from "../metadata/api/attribute";
import { getOptionsForAttr } from './coderefs';

const mapAndFormat = (array) => {
  return array.map(
    (value) => `$${formatMoneyAmountNoDecimal(parseInt(value))}`
  );
};

const formatPrevious = (previousValue) => {
  const prevArray = previousValue.split('/');
  const formatted = mapAndFormat(prevArray);
  return `${formatMoneyAmountNoDecimal(formatted)}`;
};

export function PDLimitSelector({attr, altAttr, additionalOptions, dataType, ...props}) {

  let applicationModel = useContext(ModelContext);
  let line = applicationModel.getValue(`lines{lineCd:CollectorVehicle}`);
  
  const formContext = useContext(FormContext);
  let attribute = formContext.metadata[attr];
  
  if(line.pdLimit == ""){
    line.pdLimit = "100000";
    props.value = "100000";
  }
  
  let bi = line.biLimit;
  if(bi.includes("/")){
    attribute = formContext.metadata[altAttr];
    if(line.pdLimit === "0"){
      line.pdLimit = "100000";
      props.value = "100000";
    }
  }
  else{
  	line.pdLimit = "0";
  	props.value = "0";
  }
  
  const limitOptions = getOptionsForAttr(attribute).list;
  
  if (additionalOptions && additionalOptions.length) {
    limitOptions = [...limitOptions, ...additionalOptions];
  }

  if(dataType && dataType === 'SelectUpdate'){
    let selected = null;
    let children = limitOptions.map(({value, name}) => <PortalSelectOption value={value}>
        {name}
      </PortalSelectOption>);
    const options = React.Children.map(children, el => {
        if (!el.props) {
          return null;
        }
        const obj = {
          label: el.props.children,
          value: el.props.value
        };
        if (el.props.value === props.value) {
          selected = obj;
        }
        return obj;
    });
    
    const actions = useContext(ApplicationActionsContext);
    const { setValueByAttr, getValueByAttr } = formContext;
    const previousValue = selected;
    const [selectedValue, setSelectedValue] = useState(previousValue);
    
    const handleChange = (selected) => {
      setValueByAttr(attr, selected.value);
      setSelectedValue(selected);
      if(props.setUMPD) {
        setValueByAttr('Line.UMPDLimit', selected.value);
      }
      actions.saveApplication();
    };
    return <Select
        {...props}
        aria-label="Select"
        styles={customStylesUpdater}
        title="Select"
        openMenuOnFocus
        placeholder={null}
        options={options}
        value={selected}
        onChange={handleChange}
        components={{
          IndicatorSeparator: () => null,
        }}
        theme={(theme) => ({
          ...theme,
          borderRadius: 4,
          zIndex: 3,
          colors: {
            ...theme.colors,
            primary25: 'rgb(0, 115, 157, 0.1)',
            primary: 'rgba(0, 115, 157, 0.5)',
            neutral30: 'rgba(0, 115, 157, 0.5)',
          },
        })}
      />
  }
  return <PortalSelect {...props}>
    {
      options.map(({value, name}) => <PortalSelectOption value={value}>
        {name}
      </PortalSelectOption>)
    }
  </PortalSelect>;
}

const customStylesUpdater = {
  control: (base) => ({
    ...base,
    width: '158px',
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  menu: (styles) => ({ ...styles, zIndex: 999 }),
};

PDLimitSelector.schema = BASIC_ELEMENT_SCHEMA;